module.exports = __webpack_public_path__ + "8e43072eb98c2ef04bf4907cc591e265.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/goggles.png
// module id = 2352
// module chunks = 0